import request from 'axios';
import 'whatwg-fetch';

export const SET_TOUR = 'SET_TOUR';
export const CLEAR_ORDER = 'CLEAR_ORDER';
export const SET_PROCESSING_LINK = 'SET_PROCESSING_LINK';
export const GET_PROCESSING_LINK = 'GET_PROCESSING_LINK';
export const GET_PROCESSING_LINK_REQUEST = 'GET_PROCESSING_LINK_REQUEST';
export const GET_PROCESSING_LINK_SUCCESS = 'GET_PROCESSING_LINK_SUCCESS';
export const ADD_ORDER = 'ADD_ORDER';
export const ADD_ORDER_REQUEST = 'ADD_ORDER_REQUEST';
export const ADD_ORDER_SUCCESS = 'ADD_ORDER_SUCCESS';
export const SELECT_DEPARTURE = 'SELECT_DEPARTURE';
export const SET_ORDER_PROPS = 'SET_ORDER_PROPS';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SAVE_CLIENT = 'SAVE_CLIENT';
export const SAVE_CLIENTS = 'SAVE_CLIENTS';
export const SAVE_CLIENT_SUCCESS = 'SAVE_CLIENT_SUCCESS';
export const SAVE_CLIENT_REQUEST = 'SAVE_CLIENT_REQUEST';
export const SET_CLIENT = 'SET_CLIENT';
export const CHANGE_CLIENT = 'CHANGE_CLIENT';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const CHANGE_COUNT = 'CHANGE_COUNT';
export const CALCULATE = 'CALCULATE';
export const CHANGE_OPTION_COUNT = 'CHANGE_OPTION_COUNT';
export const SET_PAY_MODE = 'SET_PAY_MODE';

export const GET_ORDER = 'GET_ORDER';
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_ORDER_FAILURE = 'GET_ORDER_FAILURE';

export const GET_CLIENTS = 'GET_CLIENTS';
export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';


var apiUrl = '';
if(process.env.NODE_ENV != 'production'){

    apiUrl = 'http://api.bn.local/';
}else{

    apiUrl = 'https://a.baikalnatu.re/';

}

export function getProcessingLink(params) {
    return {
        type: GET_PROCESSING_LINK,

        promise: fetch(apiUrl + 'rpc/bill', {method: 'POST', body: JSON.stringify(params), credentials: 'include'})
    }
}
export function addOrder(params) {
    return {
        type: ADD_ORDER,

        promise: fetch(apiUrl + 'rpc/buy', {method: 'POST', body: JSON.stringify(params), credentials: 'include'})
    }
}


export function clearOrder() {
    return {
        type: CLEAR_ORDER
    }
}

function shouldFetchOrder(state) {
    const order = state.order;
    if (!order) {
        return true;
    } else if (order.isFetching) {
        return false;
    } else {
        return true;
    }
}

export function fetchAddOrderIfNeeded(params) {
    return (dispatch, getState) => {
        if (shouldFetchOrder(getState())) {
            return dispatch(addOrder(params));
        }
    };
}


export function fetchOrderIfNeeded(order_id, user_id) {
    return (dispatch, getState) => {
        if (shouldFetchOrder(getState())) {
            return dispatch(getOrder(order_id, user_id));
        }
    };
}

export function getOrder(order_id, user_id) {
    return {
        type: GET_ORDER,
        promise: request.get(apiUrl + 'user/' + user_id + '/order/' + order_id, {withCredentials: true})
    }
}

export function getClients(order_id) {
    return {
        type: GET_CLIENTS,
        promise: request.get(apiUrl + 'order/' + order_id + '/client', {withCredentials: true})
    }
}



export function saveClient(orderId, savedClient, index) {
    let method = (savedClient.id)?'PUT':'POST';

    let client = {};
    Object.assign(client, savedClient);

    if (client.passport_issued_date) {
        client.passport_issued_date = (client.passport_issued_date)?client.passport_issued_date.unix():'';
        //console.log(client.passport_issued_date);
    }
    if (client.date_of_birth) {
        client.date_of_birth = (client.date_of_birth)?client.date_of_birth.unix():'';
        //console.log(client.date_of_birth);
    }
    if (client.passport_expiration_date) {
        client.passport_expiration_date = (client.passport_expiration_date)?client.passport_expiration_date.unix():'';
        //console.log(client.date_of_birth);
    }
    return {
        type: SAVE_CLIENT,
        payload: index,
        promise: fetch(apiUrl + 'order/'+orderId+'/client' + ((client.id)?'/'+client.id:''), {method: method, headers: {'Content-Type': 'application/json'}, body: JSON.stringify(client), credentials: 'include'})
    }
}


export function fetchSaveClientIfNeeded(orderId, client, index) {
    return (dispatch, getState) => {
        if (shouldFetchOrder(getState())) {
            return dispatch(saveClient(orderId, client, index));
        }
    };
}



export function saveClients(index) {
    return {
        type: SAVE_CLIENTS,
        payload: index
    }
}
export function setClient(result) {
    return {
        type: SET_CLIENT,
        payload: result
    }
}
export function setPayMode(config) {
    return {
        type: SET_PAY_MODE,
        payload: config
    }
}
export function changeClient(index, key, value) {

    return {
        type: CHANGE_CLIENT,
        payload: {
            index: index,
            key: key,
            value: value
        }
    }
}

export function setProcessingLink(result) {
    return {
        type: SET_PROCESSING_LINK,

        payload: result
    }
}

export function changeEmail(email) {
    return {
        type: CHANGE_EMAIL,

        payload: email
    }
}

export function calculate() {
    return {
        type: CALCULATE
    }
}

export function changeCount(count) {

    return {
        type: CHANGE_COUNT,

        payload: count
    }
}
export function changeOptionCount(option, count) {
    return {
        type: CHANGE_OPTION_COUNT,

        payload: {
            option: option,
            count: count
        }
    }
}



export function setOrderProps(props) {
    return {
        type: SET_ORDER_PROPS,

        payload: props
    }
}


export function setOptions(options) {
    return {
        type: SET_OPTIONS,
        payload: options
    }
}

export function setTour(tour, destination) {
    return {
        type: SET_TOUR,

        payload: {tour: tour, destination: destination}
    }
}


export function selectDeparture(departure) {
    return {
        type: SELECT_DEPARTURE,
        payload: departure
    }
}


// WEBPACK FOOTER //
// ./src/common/actions/order.js